import type { SupportedLocale } from '@/shared/types/i18n';

const OPERATOR_RECORDS_KEY = ['metadata-library', 'operators', 'records'] as const;

export const operatorKeys = {
  records: OPERATOR_RECORDS_KEY,
  recordsList: (q?: string, organizationIds?: readonly string[]) =>
    [...OPERATOR_RECORDS_KEY, 'infinite', q ?? '', organizationIds ?? []] as const,
  record: (recordId: string) => ['metadata-library', 'operators', 'record', recordId] as const,
  fields: (locale: SupportedLocale) => ['metadata-library', 'operators', 'fields', locale] as const,
};
